//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import trackingParamsSwitchInputTemplate from '@partials/tracking-params/tracking-params-switch-input.html';

(function () {
  const curalate = angular.module('curalate');

  curalate.directive('trackingParamsSwitchInput', [
    'TrackingParamsService',
    'SessionVarsService',
    'PermissionsService',
    function (TrackingParamsService, SessionVarsService, PermissionsService) {
      return {
        restrict: 'E',
        scope: {},
        bindToController: {
          label: '@',
          name: '@',
          placeholder: '@',
          value: '=',
          autoSet: '=',
          curalateReserved: '=',
          onEdit: '&?',
          isEditing: '=?',
          permissionsNeeded: '@',
          updateFn: '&?',
          onChangeProperty: '&?',
        },
        controllerAs: 'ctrl',
        controller: angular.noop,
        template: trackingParamsSwitchInputTemplate,
        link(scope) {
          const ctrl = scope.ctrl;

          const curalateReservedValue =
            TrackingParamsService.getReservedParameterValue();

          ctrl.v2Enabled = SessionVarsService.isFeatureEnabled(
            'url_tracking_params_v2',
          );

          ctrl.id = _.uniqueId('tracking-param-');
          ctrl.customInputValue = ctrl.autoSet ? '' : ctrl.value;
          ctrl.reservedInputName = 'Bazaarvoice Reserved';
          ctrl.autoInputName =
            TrackingParamsService.getParamDropdownOptions()[0].name;
          ctrl.autoInputValue = ctrl.autoSet
            ? ctrl.value
            : TrackingParamsService.getParamDropdownOptions()[0].value;
          ctrl.hasConfigurePermission =
            TrackingParamsService.hasConfigurePermission;
          ctrl.hasOverridePermission =
            TrackingParamsService.hasOverridePermission;
          ctrl.isTrackingParamsV2Enabled = SessionVarsService.isFeatureEnabled(
            'url_tracking_params_v2',
          );

          if (ctrl.curalateReserved) {
            ctrl.autoSet = false;
            ctrl.value = curalateReservedValue;
          }

          ctrl.hasCorrectPermissions = function () {
            return (
              ctrl.hasConfigurePermission ||
              (ctrl.permissionsNeeded === 'tracking_parameters:override' &&
                ctrl.hasOverridePermission)
            );
          };

          ctrl.hasPermissions = PermissionsService.hasPermissionForTask(
            ctrl.permissionsNeeded,
          );

          scope.$watch('ctrl.value', (value, prevValue) => {
            ctrl.callOnChangeProperty();
            if (value !== prevValue) {
              if (ctrl.autoSet) {
                ctrl.autoInputValue = value;
              } else {
                ctrl.customInputValue = value;
              }
            }
          });

          scope.$watch('ctrl.autoSet', (autoSet, prevAutoSet) => {
            ctrl.callOnChangeProperty();
            if (autoSet !== prevAutoSet) {
              if (autoSet) {
                ctrl.value = ctrl.autoInputValue;
              } else {
                ctrl.value = ctrl.customInputValue;
              }
            }
          });

          scope.$watch('ctrl.customInputValue', (value, prevValue) => {
            ctrl.callOnChangeProperty();
            if (value !== prevValue) {
              ctrl.value = value;
            }
          });

          scope.$on('trackingParams:changeReservedOption', (event, data) => {
            if (ctrl.name === data.currentValue) {
              ctrl.autoSet = false;
              ctrl.curalateReserved = true;
              ctrl.value = curalateReservedValue;
            }
            if (ctrl.name === data.previousValue) {
              ctrl.curalateReserved = false;
              ctrl.value = '';
            }
            ctrl.callOnChangeProperty();
          });

          scope.$on('trackingParams:changeAutofillOption', (event, data) => {
            _(data.previousValues).each((previousValue) => {
              if (ctrl.name === previousValue) {
                ctrl.autoSet = false;
                ctrl.curalateReserved = false;
                ctrl.value = '';
              }
            });

            _(data.currentValues).each((currentValue) => {
              if (ctrl.name === currentValue) {
                ctrl.autoSet = true;
                ctrl.curalateReserved = false;
                ctrl.value = ctrl.autoInputValue;
              }
            });
            ctrl.callOnChangeProperty();
          });

          ctrl.updateValues = (updatedValue) => {
            ctrl.updateFn({ updatedValue });
          };

          ctrl.callOnChangeProperty = () => {
            if (ctrl.onChangeProperty) {
              ctrl.onChangeProperty();
            }
          };
        },
      };
    },
  ]);
})();
